/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'OFFICE_HOURS_LOADED',
  'OFFICE_HOURS_ENABLED',
  'OFFICE_HOURS_UPDATED',
  'OFFICE_HOURS_DISABLED',
]);

export const OfficeHours = {
  START_TIME_DEFAULT: 7 * 60 * 60,
  END_TIME_DEFAULT: 19 * 60 * 60,
  DAYS_DEFAULT: [1, 2, 3, 4, 5],
};

export default {
  ActionTypes,
  OfficeHours,
};



// WEBPACK FOOTER //
// ./src/settings/constants/ChatSettingsConstants.js